import Store from 'store'
import videojs from 'video.js'
import { is_iOS_safari } from '../../../utils'

const Plugin = videojs.getPlugin('plugin')

export class ResumePlaybackPlugin extends Plugin {
  constructor(player, options = {}) {
    super(player, options)

    const playbackOffset = options.playbackOffset || 0
    const key = `videojs-resume:${options.uuid}`

    this.on(player, 'timeupdate', () => {
      Store.set(key, player.currentTime())
    })

    this.on(player, 'ended', () => {
      Store.remove(key)
    })

    player.ready(() => {
      let resumeFromTime = Store.get(key)

      if (resumeFromTime) {
        if (resumeFromTime >= playbackOffset) {
          resumeFromTime -= playbackOffset
        }
        if (resumeFromTime <= 0) {
          resumeFromTime = 0
        }

        // https://stackoverflow.com/a/11252343
        if (is_iOS_safari()) {
          this.one(player, 'loadeddata', () => {
            player.pause()
            player.currentTime(resumeFromTime)
            player.play()
          })

          return
        }

        player.currentTime(resumeFromTime)
      }
    })
  }
}
